<template>
  <LayoutBase>
    <div class="page_layout" id="global-event-listener-div">
      <div class="page_layout--inner container pt-200 pb-100 px-100">
        <slot></slot>
      </div>
    </div>
  </LayoutBase>
</template>

<script>
import LayoutBase from "../base/LayoutBase.vue";

export default {
  name: "LayoutEmptyPage",
  components: {LayoutBase},
  mounted() {
    // This is here so that html, body, and #app have height set via css
    const root = document.documentElement
    root.classList.add('layout_empty')
  },
}
</script>

<style lang="scss" scoped>

</style>
